import { useCallback, useState } from 'react';
import styled from 'styled-components';

const AdvancedFallback = () => {
  const [isReloading, setReloading] = useState(false);
  const [isDeepReloading, setDeepReloading] = useState(false);

  const handleReload = useCallback(() => {
    setReloading(true);
    window.location.reload();
  }, []);

  const handleDeepReload = useCallback(async () => {
    setDeepReloading(true);
    try {
      if (window.caches && window.caches.keys) {
        const cacheNames = await window.caches.keys();
        await Promise.all(cacheNames.map((name) => window.caches.delete(name)));
      }
      sessionStorage.clear();
      localStorage.clear();
    } finally {
      window.location.reload();
    }
  }, []);

  return (
    <Wrapper>
      <Panel>
        <Icon aria-hidden />
        <Title>Что-то пошло не так</Title>
        <Description>
          Наш интерфейс столкнулся с критической проблемой, но вы можете продолжить работу,
          сделав обычное или глубокое обновление.
        </Description>
        <ButtonRow>
          <ActionButton onClick={handleReload} disabled={isReloading || isDeepReloading}>
            {isReloading ? 'Обновляем…' : 'Обновить страницу'}
          </ActionButton>
          <ActionButton
            onClick={handleDeepReload}
            secondary
            disabled={isDeepReloading}
          >
            {isDeepReloading ? 'Глубокая перезагрузка…' : 'Глубокая перезагрузка'}
          </ActionButton>
        </ButtonRow>
      </Panel>
    </Wrapper>
  );
};

export default AdvancedFallback;

const Wrapper = styled.div`
  inset: 0;
  position: fixed;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 9999;
`;

const Panel = styled.div`
  width: min(420px, 100%);
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  color: #000000;
  padding: 36px;
  border-radius: 18px;
  box-shadow: 0 20px 40px rgba(4, 6, 22, 0.45);
  text-align: center;
`;

const Icon = styled.span`
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: #ea394b;
  display: block;
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin: 16px 0 8px;
`;

const Description = styled.p`
  font-size: 15px;
  color: #000000;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

const ActionButton = styled.button`
  flex: 1;
  min-width: 150px;
  border: none;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${(props) => (props.secondary ? '#eaeaea' : '#ea394b')};
  color: ${(props) => (props.secondary ? '#000000' : '#ffffff')};
  border: ${(props) => (props.secondary ? '1px solid #eaeaea' : 'none')};

  &:disabled {
    filter: brightness(.95);
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    filter: brightness(.95);
  }
`;
